// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2WKFI","errors":"Errors_errors__3t4Gg"};